import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Refeição',
  path: '/merenda/mertiporefeicao',
  name: 'mertiporefeicao',
  component: () => import('@/views/merenda/mertiporefeicao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEREFEICAONOVO_MENU_1000200299],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Refeição',
  path: '/merenda/mertiporefeicao/cadastro/:id?',
  parent: 'mertiporefeicao',
  name: 'mertiporefeicao_create',
  component: () => import('@/views/merenda/mertiporefeicao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEREFEICAONOVO_MENU_1000200299],
  },
  goesToMenu: true,
 },
]
